export default "__VITE_ASSET__d6bfdcd6__$_?component__"